<template>
  <div class="w-100">
    <v-menu open-on-click bottom close-delay="100" nudge-bottom="3">
      <template v-slot:activator="{ on }">
        <div class="d-flex justify-space-between align-center text-main w-100" v-on="on">
          <span class="fs-12"> Proxy Status </span>
          <ShieldIcon />
        </div>
      </template>
      <v-virtual-scroll
        :items="proxyList"
        width="300"
        height="320"
        item-height="48"
        style="background-color: #ffffff"
      >
        <template v-slot:default="{ item }">
          <v-list-item @hook:mounted="getProxyStatus(item)">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ item.ip }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <CircleSpinner v-if="item.status === 'loading'" />
              <div
                v-else-if="!isNaN(item.status) && item.status <= 399"
                style="height: 10px; width: 10px; background-color: green; border-radius: 50%"
              ></div>
              <div
                v-else-if="!isNaN(item.status) && item.status >= 400"
                style="height: 10px; width: 10px; background-color: green; border-radius: 50%"
              ></div>
              <div v-else>{{ item.status }}</div>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-virtual-scroll>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CircleSpinner from "@/components/loader/CircleSpinner.vue";
import ShieldIcon from "@/assets/svg/shieldIcon.svg";

export default {
  name: "ProxyStatus",
  components: { CircleSpinner, ShieldIcon },
  data: () => ({
    proxyList: [
      { name: "longlive-accenture-proxy-1", ip: "34.135.253.216", status: "" },
      { name: "longlive-acr-proxy-1", ip: "34.69.199.111", status: "" },
      { name: "longlive-advisor-excel-proxy-1", ip: "34.136.208.57", status: "" },
      { name: "longlive-aldermore-proxy-1", ip: "34.142.28.233", status: "" },
      { name: "longlive-aldermore-proxy-2", ip: "35.242.170.131", status: "" },
      { name: "longlive-aldermore-proxy-3", ip: "35.246.117.111", status: "" },
      { name: "longlive-aldermore-proxy-4", ip: "35.189.94.34", status: "" },
      { name: "longlive-alight-proxy-1", ip: "34.173.242.3", status: "" },
      { name: "longlive-alight-proxy-2", ip: "34.121.123.198", status: "" },
      { name: "longlive-alight-proxy-3", ip: "34.135.137.185", status: "" },
      { name: "longlive-altudo-proxy-1", ip: "34.68.65.84", status: "" },
      { name: "longlive-american-eagle-proxy-1", ip: "35.184.129.6", status: "" },
      { name: "longlive-american-eagle-proxy-2", ip: "34.172.114.148", status: "" },
      { name: "longlive-arpad-proxy-1", ip: "34.135.134.216", status: "" },
      { name: "longlive-asseco-proxy-1", ip: "35.223.132.85", status: "" },
      { name: "longlive-avidbio-proxy-1", ip: "34.69.170.164", status: "" },
      { name: "longlive-bpat-proxy-1", ip: "34.105.161.152", status: "" },
      { name: "longlive-changehealthcare-proxy-1", ip: "35.194.62.142", status: "" },
      { name: "longlive-changehealthcare-proxy-2", ip: "34.71.42.196", status: "" },
      { name: "longlive-changehealthcare-proxy-3", ip: "34.68.83.23", status: "" },
      { name: "longlive-changehealthcare-proxy-4", ip: "34.134.150.186", status: "" },
      { name: "longlive-changehealthcare-proxy-5", ip: "34.123.112.147", status: "" },
      { name: "longlive-changehealthcare-proxy-6", ip: "35.225.97.91", status: "" },
      { name: "longlive-chr-proxy-1", ip: "34.46.210.207", status: "" },
      { name: "longlive-cleardynamics-proxy-1", ip: "35.238.203.202", status: "" },
      { name: "longlive-climate-impact-proxy-1", ip: "34.173.95.5", status: "" },
      { name: "longlive-climate-impact-proxy-2", ip: "34.41.78.5", status: "" },
      { name: "longlive-codysmart-proxy-1", ip: "34.136.190.192", status: "" },
      { name: "longlive-constellation-proxy-1", ip: "34.170.57.17", status: "" },
      { name: "longlive-deckcomm-proxy-1", ip: "34.69.15.198", status: "" },
      { name: "longlive-dexcare-proxy-1", ip: "104.197.122.83", status: "" },
      { name: "longlive-diagnoseearly-proxy-1", ip: "34.173.202.79", status: "" },
      { name: "longlive-digite-proxy-1", ip: "35.226.48.209", status: "" },
      { name: "longlive-education-dynamics-proxy-1", ip: "35.223.122.54", status: "" },
      { name: "longlive-eg-dk-proxy-1", ip: "35.189.69.235", status: "" },
      { name: "longlive-eg-proxy-1", ip: "34.89.0.80", status: "" },
      { name: "longlive-eline-proxy-1", ip: "34.171.148.131", status: "" },
      { name: "longlive-equifax-1", ip: "34.132.130.169", status: "" },
      { name: "longlive-equity-residential-proxy-1", ip: "34.42.98.83", status: "" },
      { name: "longlive-exostar-proxy-1", ip: "34.41.171.225", status: "" },
      { name: "longlive-fulcrum-proxy-1", ip: "34.135.85.158", status: "" },
      { name: "longlive-ge-proxy-1", ip: "34.136.149.242", status: "" },
      { name: "longlive-greenslate-proxy-1", ip: "34.86.69.81", status: "" },
      { name: "longlive-harriswilliiams-1", ip: "34.69.169.234", status: "" },
      { name: "longlive-honeywell-proxy-1", ip: "34.82.209.73", status: "" },
      { name: "longlive-honeywell-proxy-11", ip: "104.155.153.49", status: "" },
      { name: "longlive-honeywell-proxy-12", ip: "34.135.45.247", status: "" },
      { name: "longlive-honeywell-proxy-13", ip: "34.133.150.101", status: "" },
      { name: "longlive-honeywell-proxy-14", ip: "34.71.185.36", status: "" },
      { name: "longlive-honeywell-proxy-15", ip: "34.172.147.104", status: "" },
      { name: "longlive-honeywell-proxy-16", ip: "34.173.131.128", status: "" },
      { name: "longlive-honeywell-proxy-17", ip: "35.238.248.143", status: "" },
      { name: "longlive-honeywell-proxy-18", ip: "34.32.128.211", status: "" },
      { name: "longlive-honeywell-proxy-2", ip: "35.224.66.141", status: "" },
      { name: "longlive-honeywell-proxy-8", ip: "34.67.140.194", status: "" },
      { name: "longlive-honeywell-proxy-9", ip: "35.202.38.157", status: "" },
      { name: "longlive-huntington-ingalls-proxy-1", ip: "34.94.145.30", status: "" },
      { name: "longlive-icrossing-proxy-1", ip: "34.71.237.118", status: "" },
      { name: "longlive-iifwl-proxy-1", ip: "34.71.15.228", status: "" },
      { name: "longlive-imagetrend-proxy-1", ip: "34.69.22.5", status: "" },
      { name: "longlive-inference-proxy-1", ip: "34.72.252.212", status: "" },
      { name: "longlive-intuit-proxy-1", ip: "34.69.149.49", status: "" },
      { name: "longlive-ipayables-proxy-1", ip: "34.132.220.126", status: "" },
      { name: "longlive-knowb4-proxy-1", ip: "35.222.183.180", status: "" },
      { name: "longlive-kognitiv-proxy-1", ip: "34.122.154.184", status: "" },
      { name: "longlive-kognitiv-proxy-2", ip: "34.116.78.131", status: "" },
      { name: "longlive-learningmate-proxy-1", ip: "35.239.145.32", status: "" },
      { name: "longlive-lexipol-proxy-1", ip: "104.154.227.106", status: "" },
      { name: "longlive-logixhealth-proxy-1", ip: "34.28.142.197", status: "" },
      { name: "longlive-lumen-proxy-1", ip: "35.232.121.124", status: "" },
      { name: "longlive-macfound-proxy-1", ip: "34.71.152.225", status: "" },
      { name: "longlive-madison-square-garden-proxy-1", ip: "34.171.161.223", status: "" },
      { name: "longlive-markel-proxy-1", ip: "34.132.212.65", status: "" },
      { name: "longlive-markel-proxy-2", ip: "34.142.19.20", status: "" },
      { name: "longlive-markel-proxy-3", ip: "35.222.167.86", status: "" },
      { name: "longlive-markel-proxy-4", ip: "34.121.156.163", status: "" },
      { name: "longlive-markel-proxy-5", ip: "34.123.2.235", status: "" },
      { name: "longlive-markel-proxy-6", ip: "104.198.230.5", status: "" },
      { name: "longlive-maximus-proxy-1", ip: "34.72.127.78", status: "" },
      { name: "longlive-mcafee-proxy-1", ip: "34.145.123.120", status: "" },
      { name: "longlive-mission-lane-proxy-1", ip: "35.184.241.195", status: "" },
      { name: "longlive-mpg-proxy-1", ip: "34.147.168.44", status: "" },
      { name: "longlive-nas-proxy-1", ip: "35.239.61.226", status: "" },
      { name: "longlive-nicwi-proxy-1", ip: "35.185.251.210", status: "" },
      { name: "longlive-novant-proxy-1", ip: "35.227.112.132", status: "" },
      { name: "longlive-parallel-finance-proxy-1", ip: "34.134.13.207", status: "" },
      { name: "longlive-passivelogic-proxy-1", ip: "34.136.56.190", status: "" },
      { name: "longlive-paxafe-proxy-1", ip: "34.133.77.52", status: "" },
      { name: "longlive-persistent-coe-proxy-1", ip: "34.67.213.21", status: "" },
      { name: "longlive-persistent-proxy-1", ip: "34.102.68.208", status: "" },
      { name: "longlive-proximas-proxy-1", ip: "35.230.132.10", status: "" },
      { name: "longlive-pwc-dataservices-proxy-1", ip: "35.232.175.127", status: "" },
      { name: "longlive-pwc-proxy-1", ip: "35.188.25.176", status: "" },
      { name: "longlive-pwc-proxy-accepter", ip: "35.192.107.210", status: "" },
      { name: "longlive-pwc-proxy-forwarder", ip: "34.29.134.150", status: "" },
      { name: "longlive-pwctax-proxy-1", ip: "35.222.90.216", status: "" },
      { name: "longlive-qa-proxy-1", ip: "34.173.113.128", status: "" },
      { name: "longlive-restoration-hardware-proxy-1", ip: "34.31.195.188", status: "" },
      { name: "longlive-sasser-proxy-1", ip: "34.31.184.216", status: "" },
      { name: "longlive-servicenow-proxy-1", ip: "35.226.27.66", status: "" },
      { name: "longlive-sidglobal-proxy-1", ip: "34.71.120.30", status: "" },
      { name: "longlive-sinche-proxy-1", ip: "34.132.41.246", status: "" },
      { name: "longlive-sirva-proxy-1", ip: "34.170.73.220", status: "" },
      { name: "longlive-socgen-proxy-1", ip: "34.173.231.148", status: "" },
      { name: "longlive-solution-architect-proxy-1", ip: "34.173.49.239", status: "" },
      { name: "longlive-spotnana-proxy-1", ip: "34.135.223.189", status: "" },
      { name: "longlive-srini-avirneni-proxy", ip: "34.134.159.171", status: "" },
      { name: "longlive-starbucks-proxy-1", ip: "35.222.98.227", status: "" },
      { name: "longlive-sync-computing-proxy-1", ip: "34.72.58.59", status: "" },
      { name: "longlive-syneos-proxy-2", ip: "34.66.183.116", status: "" },
      { name: "longlive-syneos-proxy-3", ip: "34.69.166.212", status: "" },
      { name: "longlive-syneos-proxy-4", ip: "34.133.85.118", status: "" },
      { name: "longlive-syneos-proxy-5", ip: "34.170.84.220", status: "" },
      { name: "longlive-sytrue-proxy-1", ip: "34.102.21.212", status: "" },
      { name: "longlive-taxslayer-proxy-1", ip: "34.123.108.152", status: "" },
      { name: "longlive-taylor-francis-proxy-1", ip: "104.197.112.46", status: "" },
      { name: "longlive-taylor-francis-proxy-2", ip: "34.72.122.68", status: "" },
      { name: "longlive-taylor-francis-proxy-3", ip: "34.30.5.50", status: "" },
      { name: "longlive-tester-proxy-2", ip: "35.238.212.72", status: "" },
      { name: "longlive-thinkhr-proxy-1", ip: "34.94.245.221", status: "" },
      { name: "longlive-thinkhr-proxy-2", ip: "34.94.145.105", status: "" },
      { name: "longlive-thinkhr-proxy-3", ip: "34.94.128.57", status: "" },
      { name: "longlive-thinkhr-proxy-4", ip: "35.236.57.11", status: "" },
      { name: "longlive-tops-jetblue-proxy-1", ip: "104.154.195.100", status: "" },
      { name: "longlive-unbabel-proxy-1", ip: "35.232.19.76", status: "" },
      { name: "longlive-upside-proxy-1", ip: "34.132.60.253", status: "" },
      { name: "longlive-upstream-proxy-1", ip: "35.193.146.72", status: "" },
      { name: "longlive-veevart-proxy-1", ip: "34.29.115.74", status: "" },
      { name: "longlive-wipro-liberty-proxy-1", ip: "34.94.243.162", status: "" },
      { name: "longlive-wipro-liberty-proxy-2", ip: "35.194.6.238", status: "" },
      { name: "longlive-wipro-poc-proxy-1", ip: "34.94.100.118", status: "" },
      { name: "longlive-xlservice-proxy-1", ip: "35.188.70.123", status: "" },
      { name: "longlive-zdenek-proxy-1", ip: "35.222.248.69", status: "" },
      { name: "longlive-zillow-proxy-1", ip: "34.172.107.45", status: "" },
    ],
  }),
  computed: {
    ...mapState({
      window: (state) => state.window,
    }),
  },
  methods: {
    getProxyStatus(proxy) {
      if (!proxy.status) {
        proxy.status = "loading";
        this.J_POST("/uiapi/detail/getproxystatus", {
          proxy_ip: proxy.ip,
        })
          .then((response) => {
            proxy.status = response.func_http_code || "N/A";
          })
          .finally(() => {});
      }
    },
  },
  created() {},
  watch: {},
};
</script>

<style lang="scss"></style>
